<template>

                                <div class="card-body">
                                 
                                    <!-- success -->
                                    <div v-if="success">
                                         <img src="assets/images/success.png" alt="banner" style="max-height:200px;display:block;margin:auto">  
                                         <h3 class="text-center">CONGRATULATIONS.. YOUR PAYMENT WAS SUCCESSFUL...</h3> 
                                         <h4 class="text-center">INVOICE BELOW</h4>
                                         <br>
                                        <div class="table-responsive" style="border:1px solid #ddd;">
                                          <table class="table table-borderless">
                                              
                                                <tr>
                                                    <td>FULL NAME</td>
                                                    <td>{{formdata.given_name || ''}} {{formdata.additional_names || ''}} {{formdata.surnames || ''}}</td>
                                                </tr>
                                                <tr>
                                                    <td>EMAIL</td>
                                                    <td>{{formdata.email}}</td>
                                                </tr>
                                             
                                                <tr>
                                                    <td>PAYMENT REFERENCE</td>
                                                    <td>{{formdata.reference}}</td>
                                                </tr>
                                                <tr>
                                                    <td>AMOUNT PAID</td>
                                                    <td>{{formdata.amount}}</td>
                                                </tr>
                                                 <tr>
                                                    <td>PAYMENT STATUS</td>
                                                    <td>{{formdata.payment.status}}</td>
                                                </tr>
                                                <tr>
                                                    <td>DATE PAID</td>
                                                    <td>{{formdata.payment.as_at}}</td>
                                                </tr>
                                         </table>
                                         
                                        </div> 
                                    </div>
                                    <!-- end success -->


                                     <!-- error -->
                                    <div v-if="error">
                                         <img src="assets/images/error.jpg" alt="banner" style="max-height:100px;display:block;margin:auto">  
                                        <br>
                                         <h3 class="text-center">OOPS.. SORRY, YOUR PAYMENT WAS NOT SUCCESSFUL...PLEASE TRY AGAIN</h3> 
                                         <h4 class="text-center">Your Details</h4>
                                         <br>
                                        <div class="table-responsive" style="border:1px solid #ddd;">
                                         <table class="table table-borderless">
                                               <!-- <tr>
                                                    <td>EVENT CODE</td>
                                                    <td>{{formdata.id}}</td>
                                                </tr> -->
                                                <tr>
                                                    <td>FULL NAME</td>
                                                    <td>{{formdata.given_name || ''}} {{formdata.additional_names || ''}} {{formdata.surnames || ''}}</td>
                                                </tr>
                                                <tr>
                                                    <td>EMAIL</td>
                                                    <td>{{formdata.email}}</td>
                                                </tr>
                                             
                                                <tr>
                                                    <td>PAYMENT REFERENCE</td>
                                                    <td>{{formdata.reference}}</td>
                                                </tr>
                                                <tr>
                                                    <td>AMOUNT PAID</td>
                                                    <td>{{formdata.amount}}</td>
                                                </tr>
                                                 <tr>
                                                    <td>PAYMENT STATUS</td>
                                                    <td>{{formdata.payment.status}}</td>
                                                </tr>
                                                 <tr>
                                                    <td>STATUS REASON</td>
                                                    <td>{{formdata.payment.status_reason}}</td>
                                                </tr>
                                                <tr>
                                                    <td>DATE PAID</td>
                                                    <td>{{formdata.payment.as_at}}</td>
                                                </tr>
                                         </table>

                                         <button class="btn btn-lg btn-ug offset-1" style="display:block:margin:auto;" @click="payAgain">TRY AGAIN</button>&nbsp;&nbsp;
                                      
                                         <br><br>
                                        </div> 
                                    </div>
                                    <!-- end error -->

                                    <!-- pending -->
                                    <div style="margin-bottom:200px" v-if="pending">
                                         <img src="assets/images/pending.gif" alt="banner" style="max-height:100px;display:block;margin:auto">  
                                        <br>
                                         <h3 class="text-center">CHECKING YOUR PAYMENT STATUS.. PLEASE WAIT</h3> 
                                    </div>
                                    <!-- end pending -->
                                    
                                </div>
       
</template>

<script>
export default {
  name: 'Status',
  props: {
    success:{
        type:Boolean,
        default:false
    }, 
     error:{
          type:Boolean,
        default:false
    }, 
    pending:{
         type:Boolean,
        default:true
    },
    formdata:{
        type:Object,
    }
  },
  methods: {
      payAgain(){
          this.$emit('tryagain',true);
      },
      printDetails(){
          this.$emit('printdetails',true);
      },
      home(){
          this.$emit('home',true);
      },
        
  },
}
</script>
<style scoped>

</style>
